/**
 * Syncs Redux user and current route into the logging service context.
 * Renders nothing; call once inside Provider (e.g. in App or index).
 */
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setLogContext } from './logger';

export function LogContextSync() {
  const userId = useSelector((state) => state.userState?.user?.user_id ?? null);

  useEffect(() => {
    setLogContext({ userId: userId ?? undefined });
  }, [userId]);

  useEffect(() => {
    const updateRoute = () =>
      setLogContext({ currentRoute: window.location?.pathname ?? '' });
    updateRoute();
    window.addEventListener('popstate', updateRoute);
    const interval = setInterval(updateRoute, 2000);
    return () => {
      window.removeEventListener('popstate', updateRoute);
      clearInterval(interval);
    };
  }, []);

  return null;
}
